import type { UCConfigInterface } from '@/libraries/usercentrics/types';

export const UC_TCF_LOCALSTORAGE_KEY: string = 'uc_tcf';

export const TCF_PROFILE: UCConfigInterface = {
	configId: 'pNbv5DOWe',
	isTCFEnabled: true,
};

export const CCPA_PROFILE: UCConfigInterface = {
	configId: 'p9i1nfAVcBcGYb',
	isTCFEnabled: false,
};
